import React,{ useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import Button, { ButtonType, ButtonTheme } from '../../atoms/button/button';
import { IconType } from '../../atoms/icon/icon';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import './formMoreInfo.scss';

const FormMoreInfo = (props) => {
    const {
        value,
        popupSize
    } = props;

    const createMarkup = () => {
        return {__html: value};
    };
    
    return (
    <OverlayTrigger
        trigger={['hover', 'focus', 'click']}
        placement="bottom"
        overlay={(
            <Popover className={(popupSize=="xl"?"xl":"")}>
                <Popover.Content>
                    <div dangerouslySetInnerHTML={createMarkup()} />
                </Popover.Content>
            </Popover>
        )}
    >
        <Button type={ButtonType.BUTTON} theme={ButtonTheme.SECONDARY} disabled={(value=='null'?true:false)} icon={IconType.CHEVRON_DOWN} />
    </OverlayTrigger>
    )
};

FormMoreInfo.propTypes = {
    popupSize: PropTypes.string,
    value: PropTypes.string,
};

export default FormMoreInfo;
